import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react'
import RenderChatContent from './renderChatContent'
import ArrowIcon from '../../assets/img/arrow.png'
import { PreviewImg } from '../../helper/imagepath'
import { useDispatch, useSelector } from 'react-redux'
import { appendImageURL, debounce } from '../../helper/function'
import { useLocation, useParams } from 'react-router-dom'
import { getChatRoom } from '../../redux/slices/chatSlice'
import { useCustomSocket } from '../../hooks/useSocket'
import { Controller, useForm } from 'react-hook-form'
import { SpinnerContext } from '../../context/spinnerContext'

const Chat = () => {
  const params = useParams()
  const dispatch = useDispatch()
  const location = useLocation()
  const endOfMessagesRef = useRef()
  const chatRoomId = params?.room_id
  const { changeLoader } = useContext(SpinnerContext)
  const [inputValue, setInputValue] = useState('')
  const { chatDetails } = useSelector((state) => state.chat)
  const { messages, socketSendMessage, socketTyping, typingUser, isUserOnline } = useCustomSocket(chatRoomId)

  useEffect(() => {
    if (location?.state) {
      changeLoader(true)
      dispatch(getChatRoom(location?.state))
        .then(() => {
          changeLoader(false)
        })
        .catch(() => {
          changeLoader(false)
        })
    }
  }, [location])

  const userName = useMemo(() => `${chatDetails?.cleaners?.first_name || ''} ${chatDetails?.cleaners?.last_name || ''}`, [chatDetails?.cleaners])
  const clientName = useMemo(() => `${chatDetails?.client?.first_name || ''} ${chatDetails?.client?.last_name || ''}`, [chatDetails?.client])

  const methods = useForm({})

  const { control, setValue } = methods

  const onHandleSendMessage = useCallback(() => {
    if (inputValue.trim()) {
      socketSendMessage(inputValue)
      setInputValue('')
      setValue('inputValue', '')
    }
  }, [inputValue])

  const debouncedInputValue = useCallback(
    debounce((val) => {
      setInputValue(val)
    }, 100),
    []
  )

  const handleInputChange = (e) => {
    const inputval = e.target.value
    debouncedInputValue(inputval)
    socketTyping(clientName)
  }

  useEffect(() => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [messages])
  return (
    <div className="page-wrapper chat-wrapper">
      <div className="chat-header">
        <div className="chat-user-info">
          <div className="user-image user-logo-container">
            <img
              src={chatDetails?.cleaners?.profile_image ? appendImageURL(chatDetails?.cleaners?.profile_image) : PreviewImg}
              alt="video-icon"
              className="user-logo"
            />
            {isUserOnline && <div className="online-user"></div>}
          </div>
          <div className="user-detail">
            <div className="user-name mb-1">{userName}</div>
          </div>
        </div>
      </div>
      <div className={`chat-content ${typingUser ? 'chat-content-type' : ''}`}>
        {messages.map((chat, index) => (
          <RenderChatContent chat={chat} key={index} endRef={endOfMessagesRef} />
        ))}
      </div>
      {typingUser && <p className="user-typing">{typingUser} Typing</p>}
      <div className="chat-footer d-flex align-items-center">
        <div className="form-group chat-input-group">
          <Controller
            name="inputValue"
            control={control}
            render={({ field: { value, onChange } }) => (
              <>
                <input
                  className="form-control"
                  type="text"
                  value={value}
                  placeholder="Start Typing..."
                  onChange={(e) => {
                    handleInputChange(e)
                    onChange(e)
                  }}
                  onKeyPress={(e) => e.code == 'Enter' && onHandleSendMessage(e)}
                />
              </>
            )}
          />
        </div>
        <div className="send-button">
          <img src={ArrowIcon} alt="arrow-icon" onClick={onHandleSendMessage} />
        </div>
      </div>
    </div>
  )
}
export default Chat
